/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CvSearchSyncProblemCategoryDto = {
    CvMissing: 'CV_MISSING',
    SendFailed: 'SEND_FAILED',
    Retrying: 'RETRYING',
    MissingInCvSearch: 'MISSING_IN_CV_SEARCH',
    NotEligibleInCvSearch: 'NOT_ELIGIBLE_IN_CV_SEARCH',
    OrphanInCvSearch: 'ORPHAN_IN_CV_SEARCH',
    TaggingFailed: 'TAGGING_FAILED',
    EmbeddingStuck: 'EMBEDDING_STUCK',
} as const;

export type CvSearchSyncProblemCategoryDto = typeof CvSearchSyncProblemCategoryDto[keyof typeof CvSearchSyncProblemCategoryDto];



